import request from '@/utils/request'

// 分配标签时使用的列表
export const tagsScenarioList = (pageData, formData) => {
    return request.get(`/tag/scenario/${pageData.page}/${pageData.pageSize}`, {params: formData})
}

// 标签分组-标签池-详情
export const detailTagGroupTagPool = (tagGroupId) => {
    return request.get(`/tag/tagGroup/tagPool/${tagGroupId}`)
}

// 标签分组-标签池-修改
export const editTagGroupTagPool = (formData) => {
    return request.put(`/tag/tagGroup/tagPool`, formData)
}

// 标签应用管理-标签池-详情
export const detailUsageScenarioTagPool = (usageScenario) => {
    return request.get(`/tag/scenario/tagPool?usageScenario=${usageScenario}`)
}

// 获取标签应用列表
export const getTagScenario = () => {
    return request.get(`/tag/scenario`)
}

// 标签应用管理-标签池-修改
export const editTagScenarioTagPool = (formData) => {
    return request.put(`/tag/scenario/tagPool`, formData)
}

// 标签管理-新增标签
export const addTagsNew = (formData) => {
    return request.post('/tag/new', formData)
}

// 标签管理-列表
export const tagsListNew = (pageData, formData) => {
    return request.post(`/tag/new/${pageData.page}/${pageData.pageSize}`, formData)
}

// 标签管理-修改标签
export const editTagsNew = (tagId, formData) => {
    return request.put(`/tag/new/${tagId}`, formData)
}

// 标签管理-修改状态
export const editTagsStateNew = (formData) => {
    return request.put(`/tag/new/state`, formData)
}

// 标签-申请记录列表
export const tagsApplicationList = (pageData, formData) => {
    return request.post(`/application/tagApplicationPage/${pageData.page}/${pageData.pageSize}`, formData)
}

// 标签组-申请记录列表
export const tagGroupPageList = (pageData, formData) => {
    return request.post(`/application/tagGroupPage/${pageData.page}/${pageData.pageSize}`, formData)
}

// 修改申请状态
export const editTagsState = (formData) => {
    return request.put(`/application/state`, formData)
}

// 批量修改申请状态
export const batchTagsOrTagGroupsState = (formData) => {
    return request.put(`/application/state/batch`, formData)
}
